import { render, staticRenderFns } from "./procedures-editor-header.vue?vue&type=template&id=1617cd04"
import script from "./procedures-editor-header.vue?vue&type=script&lang=js"
export * from "./procedures-editor-header.vue?vue&type=script&lang=js"
import style0 from "./procedures-editor-header.vue?vue&type=style&index=0&id=1617cd04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports